import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import IciciReconciliationModalUI from './IciciReconciliationModalUI'

class IciciReconciliationModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      bankStatementTransactionId: '',
      bankStatementTransactionIdError: null,
    }
  }

  render() {
    return (
      <IciciReconciliationModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        reconciliationMode={this.props.reconciliationMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        bankStatementTransactionId={this.state.bankStatementTransactionId}
        onbankStatementTransactionIdChange={(event) => this.setState({ bankStatementTransactionId: event.target.value })}
        bankStatementTransactionIdError={this.state.bankStatementTransactionIdError}
        setbankStatementTransactionIdError={(error) => { this.setState({ bankStatementTransactionIdError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    if (this.props.selectedBankTxnId !== this.state.bankStatementTransactionId) {
      this.setState({ errorList: ['TransactionId did not match'], submitted: false })
    }
    else {
      RestApiUtils.post(this.props.context,
        `/api/su/nodalTransactions/unreconciled/transaction/${this.state.bankStatementTransactionId}`,
        this.onSubmitCallback, {}
      )
    }
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  onCancelClick = () => {
    this.setState({
      bankStatementTransactionId: '',
      successMsg: null,
      errorList: [],
      submitted: false
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default IciciReconciliationModalSF
